import React from "react";
import PropTypes from "prop-types";
import { Avatar, Box, Flex, Small } from "orcs-design-system";

const CroppedImagePreview = ({ layoutMode, imageUrl, cropData }) => {
  if (layoutMode === "avatar" && cropData) {
    return (
      <Flex flexDirection="column" alignItems="center" gap="10px">
        <Avatar
          headerAvatar
          sizing="large"
          shape="square"
          image={imageUrl}
          imageAlt="Avatar with crop"
          croppedAreaPercent={cropData}
        />
        <Small>Preview</Small>
      </Flex>
    );
  }
  return (
    <Box
      width="190px"
      data-testid="cp-crop-selected-thumb"
      borderRadius="4px"
      overflow="hidden"
      boxShadow="small"
      border="1px solid"
      borderColor="greyLight"
      background="greyLighter"
      flexShrink={0}
    >
      <Box
        as="img"
        src={imageUrl}
        alt="Selected"
        width="100%"
        height="120px"
        style={{ objectFit: "cover", display: "block" }}
      />
    </Box>
  );
};

CroppedImagePreview.propTypes = {
  layoutMode: PropTypes.oneOf(["avatar", "background"]).isRequired,
  imageUrl: PropTypes.string.isRequired,
  cropData: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
};

export default CroppedImagePreview;
